import { Modal } from "antd";
import React from "react";
import Button from "../../../components/button";
import { CircleLoader } from "react-spinners";
import Cancel from "../../../assets/cancel.svg";
import useRequest from "../../../components/hooks/use-request";
import { showToast } from "../../../components/toast";
import { capitalizeFirstLetter } from "../../../utilities/functions";

const MarkAsAssociate = ({
  visible,
  handleClose,
  account,
  refetchAccount,
}: any) => {
  const { makeRequest: markAsAssociate, loading } = useRequest(
    `/users/${account?.id}/mark-as-associate`,
    "PUT"
  );

  const handleMark = async () => {
    const [response] = await markAsAssociate();
    if (response.status) {
      showToast(response.message, true, {
        position: "top-center",
      });
      refetchAccount();
      handleClose();
    } else {
      showToast(response.message || "Unable to mark user as associate", false, {
        position: "top-center",
      });
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        width={690}
        closable={true}
        footer={null}
        onCancel={handleClose}
        className="flex justify-center items-center"
      >
        <div className="flex justify-center items-center">
          <img src={Cancel} alt="Cancel" />
        </div>

        <h1 className="text-center font-bold text-[#040821] text-lg md:text-[18px]">
          Mark as Associate
        </h1>

        <p className="text-center text-base md:text-[14px] font-normal mt-4">
          Do you want to mark {capitalizeFirstLetter(account?.fullname)} as a
          sales associate?
        </p>

        <div className="flex gap-5 justify-center items-center mt-5">
          <Button
            size="lg"
            variant="secondary"
            type="submit"
            onClick={handleClose}
          >
            {loading ? (
              <CircleLoader color="#ffffff" loading={loading} size={20} />
            ) : (
              "Undo"
            )}
          </Button>

          <Button size="lg" variant="primary" type="button" onClick={handleMark}>
            {loading ? (
              <CircleLoader color="#ffffff" loading={loading} size={20} />
            ) : (
              "Proceed"
            )}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default MarkAsAssociate;
